/* eslint-disable */
const Slide = function(t) {
  function e(t, e, i, s, n) {
      this.id = t,
      this.onChange = e,
      this.page = 0,
      this.sens = 0,
      this.prefix = "/",
      this.total = 1,
      this.canSlide = !0,
      this.hasSwipe = i,
      this.progress = s,
      this.mc = null,
      this.dom = {},
      this.index = n,
      this.setDom(),
      // this.addListeners(),
      this.dom.container && (this.total = this.dom.container.getAttribute("data-total") ? parseInt(this.dom.container.getAttribute("data-total")) : this.total,
      this.total),
      this.progress && this.initProgress()
  }
  return e.prototype.setDom = function() {
      this.dom.container = document.getElementById(this.id),
      this.dom.label = document.getElementById(this.id + "-label"),
      this.dom.prev = document.getElementById(this.id + "-prev"),
      this.dom.next = document.getElementById(this.id + "-next"),
      this.progress && (this.dom.progress = document.getElementById(this.id + "-progress"),
      this.dom.progressInner = this.dom.progress.querySelector(".slider-progress-inner"))
  }
  ,
  // e.prototype.addListeners = function() {
  //     $(this.dom.prev).on("click", this.onPagination.bind(this)),
  //     $(this.dom.next).on("click", this.onPagination.bind(this)),
  //     this.hasSwipe && (N66.Device.IS_MOBILE || N66.Device.IS_TABLET) && (this.mc = new Hammer(this.dom.container),
  //     this.mc.on("swipe", this.onSwipeSlider.bind(this)))
  // }
  // ,
  // e.prototype.removeListeners = function() {
  //     $(this.dom.prev).off("click", this.onPagination.bind(this)),
  //     $(this.dom.next).off("click", this.onPagination.bind(this))
  // }
  // ,
  e.prototype.onPagination = function(t) {
      this.sens = t.currentTarget === this.dom.prev ? -1 : 1,
      this.set()
  }
  ,
  e.prototype.onSwipeSlider = function(t) {
      this.sens = t.direction === 2 ? 1 : -1,
      this.set()
  }
  ,
  e.prototype.setPage = function(t) {
      (t = this.limit(t)) !== this.page && (this.sens = t > this.page ? 1 : -1,
      this.page = t,
      this.dom.label && (this.dom.label.innerHTML = this.page + 1 + this.prefix + this.total),
      this.onChange && this.onChange(this.page, this.sens),
      this.progress && this.onProgress())
  }
  ,
  e.prototype.next = function() {
      this.sens = 1,
      this.set()
  }
  ,
  e.prototype.set = function() {
      if (this.canSlide) {
          this.canSlide = !1;
          var t = this.page + this.sens;
          (t = this.limit(t)) != this.page && (this.page = t,
          this.dom.label && (this.dom.label.innerHTML = this.page + 1 + this.prefix + this.total),
          this.onChange && this.onChange(this.page, this.sens),
          this.progress && this.onProgress())
      }
  }
  ,
  e.prototype.initProgress = function() {
      this.widthProgress = this.dom.progress.offsetWidth,
      this.widthProgressInner = this.widthProgress / this.total
  }
  ,
  e.prototype.onProgress = function() {
      var t = this.widthProgressInner * Math.ceil(this.page + 1)
        , e = new TimelineLite;
      this.page <= 0 && 1 == this.sens ? e.to(this.dom.progressInner, 1, {
          width: 0,
          x: this.widthProgress,
          ease: Quart.easeInOut
      }).set(this.dom.progressInner, {
          x: 0
      }, 1).to(this.dom.progressInner, 1, {
          width: t,
          ease: Quart.easeInOut
      }, 1) : this.page + 1 >= this.total && -1 == this.sens ? e.to(this.dom.progressInner, 1, {
          width: 0,
          ease: Quart.easeInOut
      }).set(this.dom.progressInner, {
          x: this.widthProgress
      }, 1).to(this.dom.progressInner, 1, {
          width: t,
          x: 0,
          ease: Quart.easeInOut
      }, 1) : TweenLite.to(this.dom.progressInner, 1, {
          width: t,
          ease: Quart.easeInOut
      }, 0)
  }
  ,
  e.prototype.limit = function(t) {
      return t = (t = t >= this.total ? 0 : t) < 0 ? this.total - 1 : t
  }
  ,
  e.prototype.resize = function(t, e) {}
  ,
  e.prototype.clean = function() {
      for (var t in this.removeListeners(),
      this)
          this[t] = null
  }
  ,
  e
}(window)

export default Slide
